export default function ArrowIcon({ size, className }: Icon) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			className={className}
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M4.16666 10H15.8333"
				strokeWidth="1.75"
				strokeLinecap="round"
				strokeLinejoin="round"
				stroke="currentColor"
			/>
			<path
				d="M10 4.16669L15.8333 10L10 15.8334"
				strokeWidth="1.75"
				strokeLinecap="round"
				strokeLinejoin="round"
				stroke="currentColor"
			/>
		</svg>
	);
}
